export default "__VITE_ASSET__CMAaRmlI__"